(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initHeroSlideshows = () => {
      const slideshows = document.querySelectorAll('[data-hero-slideshow]');

      slideshows.forEach((slideshow) => {
        if (slideshow.dataset.initialized === 'true') return;

        const slides = Array.from(
          slideshow.querySelectorAll('[data-hero-slide]')
        );

        if (slides.length < 2) return;

        slideshow.dataset.initialized = 'true';

        let currentIndex = 0;
        let autoplayTimer = null;

        const dotsContainer = document.createElement('div');
        dotsContainer.className = 'hero-slideshow__dots';
        dotsContainer.setAttribute('role', 'tablist');
        dotsContainer.setAttribute('aria-label', 'Hero slides');

        const dots = [];

        const previousButton = document.createElement('button');
        previousButton.type = 'button';
        previousButton.className =
          'hero-slideshow__arrow hero-slideshow__arrow--prev';
        previousButton.setAttribute('aria-label', 'Previous slide');
        previousButton.innerHTML = '&#8249;';

        const nextButton = document.createElement('button');
        nextButton.type = 'button';
        nextButton.className =
          'hero-slideshow__arrow hero-slideshow__arrow--next';
        nextButton.setAttribute('aria-label', 'Next slide');
        nextButton.innerHTML = '&#8250;';

        slides.forEach((slide, index) => {
          const dot = document.createElement('button');

          dot.type = 'button';
          dot.className = 'hero-slideshow__dot';
          dot.setAttribute('role', 'tab');
          dot.setAttribute('aria-label', `Go to slide ${index + 1}`);

          dot.addEventListener('click', () => {
            showSlide(index);
            restartAutoplay();
          });

          dotsContainer.appendChild(dot);
          dots.push(dot);
        });

        slideshow.appendChild(previousButton);
        slideshow.appendChild(nextButton);
        slideshow.appendChild(dotsContainer);

        const showSlide = (index) => {
          currentIndex = (index + slides.length) % slides.length;

          slides.forEach((slide, slideIndex) => {
            const isActive = slideIndex === currentIndex;

            slide.classList.toggle('hero-slide--active', isActive);
            slide.setAttribute('aria-hidden', isActive ? 'false' : 'true');
          });

          dots.forEach((dot, dotIndex) => {
            const isActive = dotIndex === currentIndex;

            dot.classList.toggle('is-active', isActive);
            dot.setAttribute('aria-selected', isActive ? 'true' : 'false');
          });
        };

        const restartAutoplay = () => {
          window.clearInterval(autoplayTimer);

          autoplayTimer = window.setInterval(() => {
            showSlide(currentIndex + 1);
          }, 5000);
        };

        const stopAutoplay = () => {
          window.clearInterval(autoplayTimer);
        };

        previousButton.addEventListener('click', () => {
          showSlide(currentIndex - 1);
          restartAutoplay();
        });

        nextButton.addEventListener('click', () => {
          showSlide(currentIndex + 1);
          restartAutoplay();
        });

        slideshow.addEventListener('mouseenter', stopAutoplay);
        slideshow.addEventListener('mouseleave', restartAutoplay);
        slideshow.addEventListener('focusin', stopAutoplay);
        slideshow.addEventListener('focusout', (event) => {
          if (!slideshow.contains(event.relatedTarget)) {
            restartAutoplay();
          }
        });

        showSlide(0);
        restartAutoplay();
      });
    };

    initHeroSlideshows();

    document.addEventListener('shopify:section:load', initHeroSlideshows);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
